export function isLocalhost() {
  return window.location.hostname === "localhost"
}
